import React from "react";
import { motion } from "framer-motion";

const IntroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section
      id="intro"
      className="relative min-h-screen flex items-center justify-center section-padding 
      bg-white dark:bg-gray-900 
      transition-colors duration-300"
    >
      <div className="container-custom w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-6xl mx-auto"
        >
          {/* Small Intro Text */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-lg md:text-xl mb-2 font-medium 
            text-teal-700 dark:text-accent"
          >
            Hi, my name is
          </motion.p>

          {/* Name */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl 
            font-bold leading-tight 
            text-gray-900 dark:text-gray-100"
          >
            Harshal Aglawe.
          </motion.h1>

          {/* Subtitle */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl 
            font-bold mb-4 
            text-gray-600 dark:text-gray-400"
          >
            I'm a Final Year B.Tech IT Student.
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.6 }}
            className="text-lg 
            text-gray-700 dark:text-gray-400 
            mb-4 max-w-3xl leading-relaxed"
          >
            Currently studying at St. Vincent Pallotti College, Nagpur. I build
            full-stack applications using MERN Stack and work on scalable
            backend systems with .NET, focusing on APIs, databases, and
            real-world problem solving.
          </motion.p>

          {/* Social Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="mb-8"
          >
            <p className="text-lg text-gray-700 dark:text-gray-400">
              Checkout my{" "}
              <a
                href="https://www.linkedin.com/in/harshal-aglawe"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-700 dark:text-accent hover:underline font-medium"
              >
                Linkedin
              </a>
              {" / "}
              <a
                href="https://www.github.com/harshaal06"
                target="_blank"
                rel="noopener noreferrer"
                className="text-teal-700 dark:text-accent hover:underline font-medium"
              >
                GitHub
              </a>
              .
            </p>
          </motion.div>

          {/* Resume Button */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
          >
            <button
              onClick={() => scrollToSection("contact")}
              className="
              px-6 py-3 
              border border-teal-700 dark:border-accent 
              text-teal-700 dark:text-accent 
              rounded 
              hover:bg-teal-700/10 dark:hover:bg-accent/10 
              transition-all duration-300 font-medium"
            >
              Check out my resume
            </button>
          </motion.div>
        </motion.div>
        {/* Scroll Down Button */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.8 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <button
            onClick={() => scrollToSection("about")}
            className="flex flex-col items-center text-teal-700 dark:text-accent hover:scale-110 transition-all duration-300"
          >
            <span className="text-sm mb-1">Scroll Down</span>

            <motion.div
              animate={{ y: [0, 8, 0] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </motion.div>
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroSection;
